import styled from "styled-components";

export const BarraBlancaContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
  height: 90px;
  padding: 24px 100px 0 100px;

  z-index: 2;
`;
export const BarraBlancaBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 18px;
  .BarraBlanca-title {
    color: var(--color-latex10);
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
  }
  .BarraBlanca-subtitle {
    color: var(--color-latex10);
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
  }
  .BarraBlanca-info-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 260px;
  }

  .BarraBlanca-etiquetaAzulContainer {
    display: flex;
    justify-content: center;
    width: 420px;
  }
  
  .BarraBlanca-familiar {
    width: 270px;
    padding-left: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .BarraBlanca-familiar {
    font-size: 16px;
  }
  .BarraBlanca-familiar-bold {
    font-weight: bold;
  }
`;

export const BarraBlancaBoton = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 38px;
  border-radius: 8px;
  cursor: pointer;
  color: var(--color-latex30);
  border: 2px solid var(--color-latex30);
  &::after {
    content: '';
    position: absolute;
    inset: -5px 0;
  }
`;
export const BarraBlancaBotonBlue = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 38px;
  border-radius: 8px;
  cursor: pointer;
  color: var(--color-white);
  background-color: var(--color-latex10);
  &::after {
    content: '';
    position: absolute;
    inset: -5px 0;
  }
`;
export const BarraBlancaBotonInvisible = styled.div`
  width: 104px;
  height: 38px;
`;
